export const OPEN_MODAL = "OPEN_MODAL"
export const CLOSE_MODAL = "CLOSE_MODAL"
export const SET_EVENT_TYPE = "SET_EVENT_TYPE"
export const CLEAN_EVENT_TYPE = "CLEAN_EVENT_TYPE"
export const SET_EVENT_TYPE_LIST = "SET_EVENT_TYPE_LIST"
